import featureReducer from '@sophocles/features/featureFlags/slice';

export default featureReducer;
